/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-app-footer[_ngcontent-%COMP%]{background:#cfcfcf;padding:20px 0;text-align:center}.nsc-app-footer[_ngcontent-%COMP%]     .mat-icon{font-size:12px;height:12px;width:12px;position:relative;top:2px}.nsc-app-footer[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:inherit}.nsc-app-footer[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:auto;width:150px}.nsc-app-footer__logo--nsc[_ngcontent-%COMP%]{display:block;width:96px;height:30px;margin:0 auto}.nsc-app-footer[_ngcontent-%COMP%]   .spacer_address[_ngcontent-%COMP%]{height:2px;width:2px}"];
export { styles as styles };
